import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * メンバーID
 */
export class MemberId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): MemberId {
    if (!(value.length > 0)) {
      throw new Error('内容が入力されていません');
    }
    return new MemberId(value);
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
